import type { ClimateZone } from '@/db/types';

/**
 * Day-one stub: a small hand-rolled ZIP → climate-zone lookup.
 * Real impl will hit NOAA / a climate API and pull live temps too.
 * Coverage is intentionally rough — first digit of ZIP gives a
 * reasonable US region guess for onboarding.
 */
const ZONE_BY_LEADING_DIGIT: Record<string, { zone: ClimateZone; label: string }> = {
  '0': { zone: 'cold-humid', label: 'New England' },
  '1': { zone: 'cold-humid', label: 'Northeast' },
  '2': { zone: 'mixed-humid', label: 'Mid-Atlantic' },
  '3': { zone: 'hot-humid', label: 'Southeast' },
  '4': { zone: 'cold-humid', label: 'Great Lakes' },
  '5': { zone: 'cold-humid', label: 'Upper Midwest' },
  '6': { zone: 'mixed-humid', label: 'Central Plains' },
  '7': { zone: 'mixed-humid', label: 'South Central' },
  '8': { zone: 'cold-dry', label: 'Mountain West' },
  '9': { zone: 'marine', label: 'West Coast' },
};

export function lookupClimate(
  zip: string
): { zone: ClimateZone; label: string } | null {
  const clean = zip.trim();
  if (!/^\d{5}$/.test(clean)) return null;
  const lead = clean[0];
  return ZONE_BY_LEADING_DIGIT[lead] ?? null;
}

export const CLIMATE_ZONE_LABEL: Record<ClimateZone, string> = {
  'cold-humid': 'Cold-Humid',
  'cold-dry': 'Cold-Dry',
  'mixed-humid': 'Mixed-Humid',
  'mixed-dry': 'Mixed-Dry',
  'hot-humid': 'Hot-Humid',
  'hot-dry': 'Hot-Dry',
  marine: 'Marine',
  unknown: 'Unknown',
};
